import { DocumentMapping } from "@/configuration/document-mappings/types";
import { Classification } from "@/src/models/constants/classifications";

export const TEXAS_HEART_SOUTH_HEART_MAPPINGS: Partial<Record<Classification, DocumentMapping>> = {
  [Classification.ADMIN_DISABILITY_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Nurse Liaison",
    displayName: "Disability Forms",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_Disability Forms",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.ADMIN_DISABILITY_FORMS,
    group: "south-heart",
  },
  [Classification.ADMIN_FMLA_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Nurse Liaison",
    displayName: "FMLA Forms",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_FMLA Forms",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.ADMIN_FMLA_FORMS,
    group: "south-heart",
  },
  [Classification.ADMIN_PATIENT_QUESTIONNAIRE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Nurse Liaison",
    displayName: "Patient Assistance Forms",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_Patient Assistance Forms",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.ADMIN_PATIENT_QUESTIONNAIRE,
    group: "south-heart",
  },
  [Classification.CLEARANCE_REQUEST_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider Nurse",
    displayName: "Dental Clearance",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_Dental Clearance",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.CLEARANCE_REQUEST_RESPONSE,
    group: "south-heart",
  },
  [Classification.CLEARANCE_REQUEST_SURGICAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider Nurse",
    displayName: "Surgical Clearance",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_Surgical Clearance",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.CLEARANCE_REQUEST_SURGICAL,
    group: "south-heart",
  },
  [Classification.FINANCIAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Nurse Liaison",
    displayName: "Patient Assistance APPROVAL and DENIAL",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_Patient Assistance {{ authorizationStatus }}",
    folder: "MISC",
    folderMapping: "MISC",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.FINANCIAL,
    group: "south-heart",
  },
  [Classification.IDENTIFICATION_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider scheduler",
    displayName: "DL Card / TX ID Card",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_DL Card",
    folder: "ID Card",
    folderMapping: "ID Card",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.IDENTIFICATION_CARD,
    group: "south-heart",
  },
  [Classification.IMAGING_RESULTS_CARDIAC]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider Nurse",
    displayName: "Tilt Table Test",
    documentLabel: "{{ dateOfEvent MM/DD/YYYY }}_TILT TABLE TEST_{{ Provider }}",
    folder: "EKG (All)",
    folderMapping: "EKG",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.IMAGING_RESULTS_CARDIAC,
    group: "south-heart",
  },
  [Classification.IMAGING_RESULTS_CARDIAC_LEG_IMAGING]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider Nurse",
    displayName: "Venous Doppler / Arterial Doppler / ABI",
    documentLabel: "{{ dateOfEvent MM/DD/YYYY }}_VENOUS DOPPLER_{{ Provider }}",
    folder: "Vascular Study",
    folderMapping: "Vascular Study",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.IMAGING_RESULTS_CARDIAC_LEG_IMAGING,
    group: "south-heart",
  },
  [Classification.IMAGING_RESULTS_CT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Coronary CT Angiograms → X-Ray folder", "CT Scans (ALL) → X-Ray folder"],
    assignedTo: null,
    displayName: "Calcium Scores / Coronary CT Angiograms / CT Scans (ALL)",
    documentLabel: "{{ dateOfEvent MM/DD/YYYY }}_CALCIUM SCORES_{{ Provider }}",
    folder: "Labs",
    folderMapping: "Lab Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.IMAGING_RESULTS_CT,
    group: "south-heart",
  },
  [Classification.IMAGING_RESULTS_ECHO]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Echo / TEE",
    documentLabel: "{{ dateOfEvent MM/DD/YYYY }}_ECHO_{{ Provider }}",
    folder: "Echo",
    folderMapping: "Echo",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.IMAGING_RESULTS_ECHO,
    group: "south-heart",
  },
  [Classification.IMAGING_RESULTS_EKG]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Lexiscan Tracings → Nuclear folder", "ETT Tracings → Treadmill Stress folder"],
    assignedTo: null,
    displayName: "EKG / Lexiscan Tracings / ETT Tracings",
    documentLabel: "{{ dateOfEvent MM/DD/YYYY }}_EKG_{{ Provider }}",
    folder: "EKG (All)",
    folderMapping: "EKG",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.IMAGING_RESULTS_EKG,
    group: "south-heart",
  },
  [Classification.IMAGING_RESULTS_HOLTER_MONITOR]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "End Of Service Reports (Biotel / MCT) / Holter Reports",
    documentLabel: "{{ dateOfEvent MM/DD/YYYY }}_END OF SERVICE REPORTS_{{ Provider }}",
    folder: "Event, Holter, PPM, ICD",
    folderMapping: "EVENT HOLTER PPM ICD",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.IMAGING_RESULTS_HOLTER_MONITOR,
    group: "south-heart",
  },
  [Classification.IMAGING_RESULTS_MONITOR_NOTIFICATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Cardio MEMS → Infusion folder",
      "Zoll Follow up Reports / Summary → Patient Documents folder",
    ],
    assignedTo: "Provider Nurse",
    displayName: "PMK Tracings / Daily Reports (Biotel / MCT) / Cardio MEMS / Zoll Follow up Reports",
    documentLabel: "{{ dateOfEvent MM/DD/YYYY }}_PMK TRACINGS_{{ Provider }}",
    folder: "Event, Holter, PPM, ICD",
    folderMapping: "EVENT HOLTER PPM ICD",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.IMAGING_RESULTS_MONITOR_NOTIFICATION,
    group: "south-heart",
  },
  [Classification.IMAGING_RESULTS_MRI]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "MRI / MRA",
    documentLabel: "{{ dateOfEvent MM/DD/YYYY }}_MRI_{{ Provider }}",
    folder: "X-Ray",
    folderMapping: "X Ray Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.IMAGING_RESULTS_MRI,
    group: "south-heart",
  },
  [Classification.IMAGING_RESULTS_NM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["VQ Scan → X-Ray folder"],
    assignedTo: null,
    displayName: "MUGA Reports / VQ Scan",
    documentLabel: "{{ dateOfEvent MM/DD/YYYY }}_MUGA REPORTS_{{ Provider }}",
    folder: "Nuclear",
    folderMapping: "Nuclear Cardiology",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.IMAGING_RESULTS_NM,
    group: "south-heart",
  },
  [Classification.IMAGING_RESULTS_PET]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Myocardial Perfusion",
    documentLabel: "{{ dateOfEvent MM/DD/YYYY }}_MYOCARDIAL PERFUSION_{{ Provider }}",
    folder: "Nuclear",
    folderMapping: "Nuclear Cardiology",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.IMAGING_RESULTS_PET,
    group: "south-heart",
  },
  [Classification.IMAGING_RESULTS_PULMONARY_FUNCTION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "PFT Report / Spirometry",
    documentLabel: "{{ dateOfEvent MM/DD/YYYY }}_PFT REPORT_{{ Provider }}",
    folder: "EKG (All)",
    folderMapping: "EKG",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.IMAGING_RESULTS_PULMONARY_FUNCTION,
    group: "south-heart",
  },
  [Classification.IMAGING_RESULTS_STRESS_TEST_EXERCISE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Stress Test → Treadmill Stress folder", "ETT Data Sheet → Treadmill Stress folder"],
    assignedTo: null,
    displayName: "Dobutamine Stress Echo / Stress Test / ETT Data Sheet",
    documentLabel: "{{ dateOfEvent MM/DD/YYYY }}_DOBUTAMINE STRESS ECHO_{{ Provider }}",
    folder: "Echo",
    folderMapping: "Echo",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.IMAGING_RESULTS_STRESS_TEST_EXERCISE,
    group: "south-heart",
  },
  [Classification.IMAGING_RESULTS_STRESS_TEST_NM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Lexiscan Reports",
    documentLabel: "{{ dateOfEvent MM/DD/YYYY }}_LEXISCAN REPORTS_{{ Provider }}",
    folder: "Nuclear",
    folderMapping: "Nuclear Cardiology",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.IMAGING_RESULTS_STRESS_TEST_NM,
    group: "south-heart",
  },
  [Classification.IMAGING_RESULTS_ULTRASOUND]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Ultrasounds (ALL) → X-Ray folder"],
    assignedTo: null,
    displayName: "Carotid Doppler / Abdominal Aorta / Ultrasounds (ALL)",
    documentLabel: "{{ dateOfEvent MM/DD/YYYY }}_CAROTID DOPPLER_{{ Provider }}",
    folder: "Vascular Study",
    folderMapping: "Vascular Study",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.IMAGING_RESULTS_ULTRASOUND,
    group: "south-heart",
  },
  [Classification.IMAGING_RESULTS_X_RAY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "X-Ray Reports (ALL)",
    documentLabel: "{{ dateOfEvent MM/DD/YYYY }}_X-RAY REPORTS_{{ Provider }}",
    folder: "X-Ray",
    folderMapping: "X Ray Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.IMAGING_RESULTS_X_RAY,
    group: "south-heart",
  },
  [Classification.INSURANCE_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider scheduler",
    displayName: "Insurance Cards",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_INSURANCE CARDS",
    folder: "Insurance Cards",
    folderMapping: "Insurance Cards",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.INSURANCE_CARD,
    group: "south-heart",
  },
  [Classification.JUNK]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Ads, blank pages, etc.",
    documentLabel: "",
    folder: null,
    folderMapping: null,
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Delete",
    classification: Classification.JUNK,
    group: "south-heart",
  },
  [Classification.LAB_RESULTS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider Nurse",
    displayName: "Labs",
    documentLabel: "{{ collectionDate MM/DD/YYYY }}_LABS_{{ Provider }}",
    folder: "Labs",
    folderMapping: "Lab Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.LAB_RESULTS,
    group: "south-heart",
  },
  [Classification.LAB_RESULTS_BP]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider Nurse",
    displayName: "Blood Pressure Logs",
    documentLabel: "{{ collectionDate MM/DD/YYYY }}_BLOOD PRESSURE LOGS_{{ Provider }}",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.LAB_RESULTS_BP,
    group: "south-heart",
  },
  [Classification.LAB_RESULTS_ORDER_FORM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Attach to correct labs that were faxed"],
    assignedTo: null,
    displayName: "Lab confirmations",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_LAB CONFIRMATIONS_{{ Provider }}",
    folder: "Labs",
    folderMapping: "Lab Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.LAB_RESULTS_ORDER_FORM,
    group: "south-heart",
  },
  [Classification.LEGAL_ADVANCED_CARE_DIRECTIVE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Mark High Priority"],
    assignedTo: null,
    displayName: "Do Not Resuscitate (DNR)",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_DNR",
    folder: "Advance Directive Documents (High Priority)",
    folderMapping: "AdvDirective Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.LEGAL_ADVANCED_CARE_DIRECTIVE,
    group: "south-heart",
  },
  [Classification.LEGAL_POWER_OF_ATTORNEY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Mark High Priority"],
    assignedTo: null,
    displayName: "Power of Attorney (POA)",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_POA",
    folder: "Advance Directive Documents (High Priority)",
    folderMapping: "AdvDirective Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.LEGAL_POWER_OF_ATTORNEY,
    group: "south-heart",
  },
  [Classification.MEDICAL_HISTORY_CHART_FROM_CLINIC]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Health Summary / Patient Summary",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_HEALTH SUMMARY_{{ Provider }}",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.MEDICAL_HISTORY_CHART_FROM_CLINIC,
    group: "south-heart",
  },
  [Classification.MEDICAL_HISTORY_CHART_FROM_HOSPITAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "H & P / Consult Notes",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_H & P_{{ Provider }}",
    folder: "Consult Notes (Hospital Only)",
    folderMapping: "Consult Notes",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.MEDICAL_HISTORY_CHART_FROM_HOSPITAL,
    group: "south-heart",
  },
  [Classification.MEDICAL_HISTORY_HOME_HEALTH]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Home Health",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_HOME HEALTH_{{ Provider }}",
    folder: "MISC",
    folderMapping: "MISC",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.MEDICAL_HISTORY_HOME_HEALTH,
    group: "south-heart",
  },
  [Classification.MEDICAL_HISTORY_IMMUNIZATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Vaccine Record",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_VACCINE RECORD_{{ Provider }}",
    folder: "Immunizations",
    folderMapping: "Immunization Forms",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.MEDICAL_HISTORY_IMMUNIZATION,
    group: "south-heart",
  },
  [Classification.MEDICAL_HISTORY_MEDICATIONS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Prescriptions",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_PRESCRIPTIONS_{{ Provider }}",
    folder: "Specialty",
    folderMapping: "Specialty Forms",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.MEDICAL_HISTORY_MEDICATIONS,
    group: "south-heart",
  },
  [Classification.MEDICAL_RECORD_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Requests@provider1st.com",
    displayName: "Release of Information (ROI)",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_RELEASE OF INFORMATION",
    folder: "MISC",
    folderMapping: "MISC",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Email",
    classification: Classification.MEDICAL_RECORD_REQUEST,
    group: "south-heart",
  },
  [Classification.ORDER_LAB]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Nurse Liaison",
    displayName: "Lab Order",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_LAB ORDER_{{ Provider }}",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.ORDER_LAB,
    group: "south-heart",
  },
  [Classification.OTHER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Morales,Maria",
    displayName: "All other documents",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_Patient Forms",
    folder: "MISC",
    folderMapping: "MISC",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.OTHER,
    group: "south-heart",
  },
  [Classification.PHARMACY_RELATED]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Nurse Liaison",
    displayName: "RX Related",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_RX Related",
    folder: "MISC",
    folderMapping: "MISC",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.PHARMACY_RELATED,
    group: "south-heart",
  },
  [Classification.PRIOR_AUTHORIZATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Nurse Liaison",
    displayName: "Prior Auths",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_PRIOR AUTHS_{{ Provider }}",
    folder: "MISC",
    folderMapping: "MISC",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.PRIOR_AUTHORIZATION,
    group: "south-heart",
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Nurse Liaison",
    displayName: "Prior Auths (Medication Request)",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_Prior Auths (Medication Request)",
    folder: "MISC",
    folderMapping: "MISC",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST,
    group: "south-heart",
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Nurse Liaison",
    displayName: "Prior Auths (Medication Response)",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_Prior Auths (Medication Response)",
    folder: "MISC",
    folderMapping: "MISC",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE,
    group: "south-heart",
  },
  [Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Cavazos,Linda",
    displayName: "Prior Auths (Procedure Request)",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_Prior Auths (Procedure Request)",
    folder: "MISC",
    folderMapping: "MISC",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST,
    group: "south-heart",
  },
  [Classification.PRIOR_AUTHORIZATION_PROCEDURE_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Cavazos,Linda",
    displayName: "Prior Auths (Procedure Response)",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_Prior Auths (Procedure Response)",
    folder: "MISC",
    folderMapping: "MISC",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.PRIOR_AUTHORIZATION_PROCEDURE_RESPONSE,
    group: "south-heart",
  },
  [Classification.PROCEDURE_CARDIAC]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Cardioversion Reports → EP Studies folder (If Provider = Dr Mazzola, assign to Corona,Paige)",
      "Ablation Reports → EP Studies folder (If Provider = Dr Mazzola, assign to Corona,Paige)",
      "EP Study Reports → EP Studies folder (If Provider = Dr Mazzola, assign to Corona,Paige)",
      "PMK Insertion Reports → Procedure Documents folder (If Provider = Dr Mazzola, assign to Corona,Paige)",
      "TAVR → Procedure Documents folder",
    ],
    assignedTo: null,
    displayName: "Cath Diagram / Cath Report / Cardioversion / Ablation / EP Study / PMK Insertion / TAVR",
    documentLabel: "{{ dateOfEvent MM/DD/YYYY }}_CATH DIAGRAM_{{ Provider }}",
    folder: "Cardiac Cath",
    folderMapping: "Cardiac Cath",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.PROCEDURE_CARDIAC,
    group: "south-heart",
  },
  [Classification.PROCEDURE_CARDIAC_VEIN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Peripheral Diagram / Vein Clinic Operative Reports / Venograms",
    documentLabel: "{{ dateOfEvent MM/DD/YYYY }}_PERIPHERAL DIAGRAM / REPORT_{{ Provider }}",
    folder: "Procedure Documents",
    folderMapping: "Procedure Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.PROCEDURE_CARDIAC_VEIN,
    group: "south-heart",
  },
  [Classification.PROCEDURE_DEVICE_INFO]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Device Implant Cards → Event, Holter, PPM, ICD folder (If Provider = Dr Mazzola, assign to Corona,Paige)",
      "MRI Compatibility → MISC folder, assign to Corona,Paige",
    ],
    assignedTo: null,
    displayName: "Patient Stent Cards / Device Implant Cards / MRI Compatibility",
    documentLabel: "{{ dateReceived MM/DD/YYYY }}_Patient Stent Cards",
    folder: "Cardiac Cath",
    folderMapping: "Cardiac Cath",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.PROCEDURE_DEVICE_INFO,
    group: "south-heart",
  },
  [Classification.PROCEDURE_REHAB]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Rehab Reports",
    documentLabel: "{{ dateOfEvent MM/DD/YYYY }}_Rehab Reports",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.PROCEDURE_REHAB,
    group: "south-heart",
  },
  [Classification.PROCEDURE_SLEEP]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Sleep Studies",
    documentLabel: "{{ dateOfEvent MM/DD/YYYY }}_SLEEP STUDIES_{{ Provider }}",
    folder: "EKG (All)",
    folderMapping: "EKG",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.PROCEDURE_SLEEP,
    group: "south-heart",
  },
  [Classification.PROGRESS_NOTE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Progress Notes (Referring Doctors) → Patient Documents folder"],
    assignedTo: null,
    displayName: "Progress Note / Progress Notes (Referring Doctors)",
    documentLabel: "{{ dateOfEvent MM/DD/YYYY }}_PROGRESS NOTE_{{ Provider }}",
    folder: "Consult Notes (Hospital Only)",
    folderMapping: "Consult Notes",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.PROGRESS_NOTE,
    group: "south-heart",
  },
  [Classification.PROGRESS_NOTE_ER_REPORT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "ER Note",
    documentLabel: "{{ dateOfEvent MM/DD/YYYY }}_ER NOTE_{{ Provider }}",
    folder: "Consult Notes (Hospital Only)",
    folderMapping: "Consult Notes",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.PROGRESS_NOTE_ER_REPORT,
    group: "south-heart",
  },
  [Classification.PROGRESS_NOTE_OFFICE_VISIT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Requests@provider1st.com",
    displayName: "Chart Review",
    documentLabel: "{{ dateOfEvent MM/DD/YYYY }}_Chart Review",
    folder: "MISC",
    folderMapping: "MISC",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Email",
    classification: Classification.PROGRESS_NOTE_OFFICE_VISIT,
    group: "south-heart",
  },
  [Classification.REFERRAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider scheduler",
    displayName: "Referrals",
    documentLabel: "{{ dateReferral MM/DD/YYYY }}_REFERRALS_{{ Provider }}",
    folder: "Referrals",
    folderMapping: "Referral Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.REFERRAL,
    group: "south-heart",
  },
} as const;
